<template>
  <div>
    <div style="height: 100%">
      <div class="section">
        <div class="biaodan2">
          <div class="biaodan-left">
            <div style="height: 100%; width: 100%">
              <el-form
                :inline="true"
                label-position="left"
                class="demo-form-inline"
                :model="form"
              >
              <el-form-item label="商户名称">
                  <el-input
                    v-model="form.pbmc"
                    clearable
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
                <el-form-item label="所属片区">
                  <el-input
                    v-model="form.pian"
                    clearable
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
                <el-form-item label="所属社区">
                  <el-input
                    v-model="form.sq"
                    clearable
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
                <el-form-item label="所属联盟">
                  <el-input
                    v-model="form.zu"
                    clearable
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
                <el-form-item label="负责人">
                  <el-input
                    v-model="form.zrr"
                    clearable
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
                <el-form-item label="审核状态">
                  <el-select
                    filterable
                    placeholder="请选择"
                    clearable
                    v-model="form.zcCheckStatus"
                  >
                    <el-option
                      v-for="item in applyResult"
                      :key="item.value"
                      :label="item.text"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="form-item">
                  <el-button @click="onSearch" class="search">查询</el-button>
                  <el-button class="reset" @click="onReset">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
        <div class="aside">
          <common-table
            :select="false"
            :page="page"
            :dataList="dataList"
            @handleCurrentChange="handleCurrentChange"
            @handleSizeChange="handleSizeChange"
            :maxHeight="560"
          >
            <template v-slot:zcCheckStatus="{ scope }">
              <span class="noPass" v-if="scope.row.zcCheckStatus == 'reject'">{{ zcCheckStatusObj[scope.row.zcCheckStatus] }}</span>
              <span class="pass" v-else>{{ zcCheckStatusObj[scope.row.zcCheckStatus] }}</span>
            </template>
            <template v-slot:operation="{ scope }">
              <el-button
                style="font-size: 16px"
                type="text"
                @click="toDetail(scope.row)"
                >审核</el-button
              >
            </template>
          </common-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  userShanghuPage,
  shanghuInfoDetail,
} from "@/api/shanghu";
import commonTable from "@/components/table/index.vue";
export default {
  components: {
    commonTable
  },
  data() {
    return {
      loading: false,
      form: {
        pbmc: "",
        pian: "",
        sq: "",
        zu: "",
        zrr: "",
        zcCheckStatus: ""
      },
      page: {
        size: 10,
        page: 1,
        total: 0
      },
      dataList: {
        tableData: [],
        columns: [
          {
            prop: "pbmc",
            label: "商户名称"
          },
          {
            prop: "tyshxydm",
            label: "统一社会信用代码",
            width: '200px'
          },
          {
            prop: "sfyy",
            label: "是否营业"
          },
          {
            prop: "zrr",
            label: "负责人"
          },
          {
            prop: "zrrsjh",
            label: "负责人联系电话"
          },
          {
            prop: "pian",
            label: "所属片区"
          },
          {
            prop: "sq",
            label: "所属社区"
          },
          {
            prop: "zu",
            label: "所属联盟"
          },
          {
            prop: "userName",
            label: "上报人"
          },
          {
            prop: "phone",
            label: "上报人联系电话"
          },
          // {
          //   prop: "zrztdz",
          //   label: "所在地址"
          // },
          {
            slot: "zcCheckStatus",
            label: "审核状态"
          },
          {
            slot: "operation",
            label: "操作"
          }
        ]
      },
      applyResult: [
        {
          text: '审核通过',
          value: "pass"
        },
        {
          text: '审核不通过',
          value: "reject"
        },
        {
          text: '待审核',
          value: "waiting"
        }
      ],
      zcCheckStatusObj: {
        "pass": "审核通过",
        "reject": "审核不通过",
        "waiting": "待审核",
      },
      formInline: {},
      showDetail: false,
    };
  },
  mounted() {
    if (sessionStorage.getItem('shxtSearch')) {
      this.form = JSON.parse(sessionStorage.getItem('shxtSearch'));
      this.page = {
        size: JSON.parse(sessionStorage.getItem('shxtSearch')).size,
        page: JSON.parse(sessionStorage.getItem('shxtSearch')).page,
        total: JSON.parse(sessionStorage.getItem('shxtSearch')).total
      }
    }
    this.getPointTypeListPageFun();
  },
  methods: {
    // 详情
    async toDetail(row) {
      // console.log(JSON.parse(JSON.stringify(row)))
      let res = await shanghuInfoDetail({
        id: row.id
      });
      if (res.data.code == 200) {
        this.showDetail = true; 
        this.formInline = JSON.parse(JSON.stringify(res.data.data));
        this.$emit('showShShDetail', {item: {
          ...this.formInline,
          ...row,
          zcCheckStatus: row.zcCheckStatus,
          zcCheckOpinion: row.zcCheckOpinion,
          formShId: row.formShId
        }})
      }
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getPointTypeListPageFun();
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.getPointTypeListPageFun();
    },

    // 查询字典类型列表
    onSearch() {
      this.page.page = 1;
      this.page.size = 10;
      sessionStorage.setItem('shxtSearch', JSON.stringify({
        ...this.form,
        ...this.page
      }));
      this.getPointTypeListPageFun();
    },
    onReset() {
      this.form.pbmc = "";
      this.form.pian = "";
      this.form.sq = "";
      this.form.zu = "";
      this.form.zrr = "";
      this.form.zcCheckStatus = "";
      this.page.page = 1;
      this.page.size = 10;
      sessionStorage.removeItem('shxtSearch');
      this.getPointTypeListPageFun();
    },
    // 分页查询
    async getPointTypeListPageFun() {
      this.loading = true;
      let params = {
        ...this.form,
        page: this.page.page, 
        size: this.page.size,
        zcUserTypeEq: "wait-shanghu"
      };
      const res = await userShanghuPage(params);
      if (res.data.code == 200) {
        this.dataList.tableData = res.data.data.records
          ? res.data.data.records.map(item => {
            return {
              formShId: item.id,
              ...item,
              ...item.shanghuInfo

            }
          })
          : [];
        this.page.total = res.data.data.total ? Number(res.data.data.total) : 0;
      }
      this.loading = false;
    },
  }
};
</script>
<style scoped lang="less">
@import "~@/components/less.less";

.biaodan2 {
  width: 100%;
  margin-top: 1px;
  display: block;

  .form-item {
    padding: 0;
    margin: 0;
  }
}

.biaodan-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.flex {
  display: flex;
}
.demo-form-inline {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
}

.section .el-form-item__label {
  text-align: left;
}

.el-button {
  height: 40px;
  font-size: 16px;
}

.table-header {
  height: 56px;
  padding: 8px 0;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

/deep/.el-pagination .el-input--mini .el-input__inner,
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li,
/deep/.el-pagination__jump .el-input__inner {
  height: 32px;
  line-height: 32px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border-radius: 4px;
  border: 1px solid #0495ff;
  color: #0495ff;
  background: none;
}

/deep/.el-pagination__jump {
  margin-left: 0;
}

.question-detail {
  height: calc(100% - 56px);
  background-color: #fff;
  border-radius: 8px 8px 0px 0px;

  .top {
    width: 100%;
    // height: 178px;
    padding: 24px 36px;
    background: url("~@/assets/image/question-bg.png") no-repeat center;
    background-size: 100% 100%;
  }
  .map-content {
    width: 375px;
    height: 178px;
    margin: 0 24px;
  }
}

.right-top1 {
  // width: 100%;
  margin-bottom: 8px;
  padding: 10px 24px;
  position: relative;

  .street {
    font-family: MiSans, MiSans;
    font-weight: 700;
    font-size: 24px;
    color: #494c4f;
    position: relative;
    .disposition {
      position: absolute;
      top: -10px;
      right: -80px;
      img {
        width: 65px;
        height: 54px;
      }
    }
  }

  .content {
    margin-top: 8px;
    font-family: MiSans, MiSans;
    font-weight: 400;
    font-size: 18px;
    color: #494c4f;
  }
  .info-box {
    margin-top: 12px;
    display: flex;
    align-items: center;

    .info-box-item {
      display: flex;
      align-items: center;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 16px;
      color: #494c4f;
      margin-right: 54px;

      img,
      span {
        margin-right: 8px;
      }

      img {
        height: 15px;
      }
    }

    .info-box-item:last-child {
      margin-right: 0;
    }
  }
}

.right-bottom {
  height: calc(100% - 214px);
  width: 100%;
  // max-height: 719px;
  // min-height: 561px;

  .tabs {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 100px;
    padding-right: 24px;
    margin-bottom: 8px;

    .tabs-box {
      display: flex;
      align-items: center;

      .tabs-item {
        padding-top: 10px;
        padding-bottom: 8px;
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 20px;
        color: #92979c;
        margin-right: 48px;
        cursor: pointer;
        position: relative;
      }

      .tabs-item.active {
        font-family: MiSans, MiSans;
        font-weight: 700;
        font-size: 20px;
        color: #494c4f;
      }

      .tabs-item.active::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        height: 4px;
        width: 100%;
        background: #0090ff;
        border-radius: 2px;
      }
    }

    .tupian-box {
      display: flex;
      align-items: center;

      width: 68px;

      .tupian-item {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        padding: 8px;
        height: 38px;
      }

      .tupian-item:first-child {
        border-radius: 4px 0px 0px 4px;
        border: 1px solid #e0e0e0;

        img {
          height: 16px;
        }
      }

      .tupian-item:last-child {
        border-radius: 0px 4px 4px 0px;
        border: 1px solid #e0e0e0;

        img {
          height: 20px;
        }
      }
    }
  }

  .map-content {
    width: 100%;
    height: calc(100% - 56px);
    // min-height: 505px;
  }
}

.form-content {
  padding: 20px 100px;
}
.taskDetail {
  /deep/ .el-form-item__label {
    text-align: left;
  }
}

.keyPic {
  margin-top: 8px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  /deep/ .el-image {
    margin: 0 !important;
  }
  .imgPic {
    width: 234px;
    height: 234px;
    margin-right: 10px !important;
    border-radius: 4px;
  }
}

.fenbo {
  width: 410px;
  border-right: 1px solid #e0e0e0;
  margin-right: 20px;

  .list {
    width: 390px;

    height: 72px;
    background: #f7faff;
    border-radius: 4px;
    padding: 12px 24px;
    position: relative;
    margin-bottom: 12px;

    .handleDeptName {
      font-family: MiSans, MiSans;
      font-weight: 500;
      font-size: 16px;
      color: #494c4f;
      line-height: 22px;
    }
    .assignType {
      margin-right: 8px;
      padding: 0 4px;
      height: 22px;
      background: rgba(138, 144, 154, 0.09);
      border-radius: 4px;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 14px;
      color: #92979c;
      line-height: 22px;
    }
    .zhuban {
      background: rgba(4, 149, 255, 0.1);
      color: #0495ff;
    }
    .assignTime {
      margin-top: 8px;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 14px;
      color: #92979c;
      line-height: 19px;
    }
    .disposition {
      position: absolute;
      top: 10px;
      right: 20px;
      img {
        width: 65px;
        height: 54px;
      }
    }
  }
  .activeList {
    border: 1px solid #0495ff;
  }
}

.tuihui {
  color: #eb3538;
  font-size: 16px;
}

.yituihui {
  color: #c4c6cc;
}
.pass {
  color: #17B3AD;
}
.noPass {
  color: #FF5348;
}
</style>



// WEBPACK FOOTER //
// src/pages/AuthenticationAuthority/userManagement/shxtList.vue